import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { useAppStateStore } from '@/features/application'
import { typeContextCourantToContextAppType } from '@/features/auth/context-app/types/ContextApp'
import type { RouteName } from '@/router/route-name'

export function useNavigationTabs(routeNames: RouteName[]) {
  const router = useRouter()
  const appState = useAppStateStore()

  const getRouteByName = (name: RouteName) => router.getRoutes().find((r) => r.name === name)

  const isAccessible = (name: RouteName) => !getRouteByName(name)?.meta?.requiresAdmin || appState.estAdmin

  const tabs = computed(() => routeNames.filter((name) => isAccessible(name)).map((name) => ({ tabKey: name })))

  const goToTab = (name: RouteName) => {
    const _ = router.push({ name, params: {
        context: typeContextCourantToContextAppType(appState.contextCourant),
      }
    })
  }

  return {
    tabs,
    goToTab,
  }
}
